
import React from "react";
import axios from "axios";

const FileDownloader = ({ fileUrl, fileName, btnLabel }: any) => {
  const handleDownload = async () => {
    try {
      const response = await axios.get(fileUrl, {
        responseType: "blob", // crucial: tells Axios to treat the response as binary
      });

      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed", error);
    }
  };

  return (
    <button onClick={handleDownload} className="btn btn-normal-2">
      <i className="fas fa-download"></i>{' '}
      {btnLabel}
    </button>
  )
};

export default FileDownloader
